module.exports = __webpack_public_path__ + "static/media/slogan.1d62dba0.png";